// src/beta/services/provenance.ts
import { betaFetch } from '@/beta/services/api';
import type { V1ProvenanceEntry } from '@/beta/types/dossier';

interface ProvenanceResponse {
  version: 1;
  vehicle_id: string;
  data: { entries: V1ProvenanceEntry[]; total: number };
  generated_at: string;
}

/** GET /v1/vehicles/[id]/provenance — chronological provenance entries. */
export async function getProvenance(vehicleId: string) {
  const res = await betaFetch<ProvenanceResponse>(`/vehicles/${vehicleId}/provenance`);
  return res.data;
}
